import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as criteriaTopsportActions from "../../actions/criteriaTopsportActions";
import * as layoutActions from "../../actions/layoutActions";
import * as types from "../../constants/ComponentConstants";
import * as documentActions from "../../actions/documentActions";

import AutoBindComponent from "../common/AutoBindComponent";
import BeoordelingscriteriaTopsportForm from "./BeoordelingscriteriaTopsportForm";
import BeoordelingscriteriaTopsportPageHelper from "./BeoordelingscriteriaTopsportPageHelper";
import unsavedDataDialogHandler from "../common/UnsavedDataDialogHandler";

import EasterEggHandler from "../common/EasterEggHandler";
import * as pageConstants from "../../constants/EasterEggConstants";


class BeoordelingscriteriaTopsportPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			titleSet: false,
			fileSessionStarted: false,
			hasUnsavedChanges: false
		};

		this.pageHelper = new BeoordelingscriteriaTopsportPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.CRITERIATOPSPORT);
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.receiveProps(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	handleOnChange(event) {
		this.pageHelper.onChange(event);
	}

	handleOnDropFiles(component, files) {
		this.pageHelper.onDropFiles(component, files);
	}

	handleOnDeleteFile(component, fileName) {
		this.pageHelper.onDeleteFile(component, fileName);
	}

	handleOnSave(event) {
		this.pageHelper.onSave(event);
	}

	saveTheModel() {
		this.pageHelper.saveTheModel();
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}
	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	isReadyToRender() {
		// entity not loaded? not ready yet...
		if (!this.state.beoordelingscriteria) {
			return false;
		}

		return true;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}
		const validationMessageType = this.props.validationMessageType;

		return (
			<BeoordelingscriteriaTopsportForm
				beoordelingscriteria={this.state.beoordelingscriteria}
				documenten={this.state.documenten}
				disabled={this.props.loading}
				fileTypes={this.props.fileTypes}
				errors={this.props.errors}
				onChange={this.handleOnChange}
				onSave={this.handleOnSave}
				onDropFiles={this.handleOnDropFiles}
				onDeleteFile={this.handleOnDeleteFile}
				color={types.COLOR_ORANGE}
				validationMessageType={validationMessageType}
			/>
		);
	}
}

// ----------------------------------------------------------------------------
BeoordelingscriteriaTopsportPage.propTypes = {
	beoordelingscriteria: PropTypes.object,
	loading: PropTypes.bool,
	fileTypes: PropTypes.object

};

function mapStateToProps(state, ownProps) {
	const dossierId = ownProps.params.dossierId;
	const beoordelingscriteria = state.beoordelingscriteria;
	const disabled = state.ajaxCounter > 0 || state.settings.lockAllDossiers || ((beoordelingscriteria.item) && beoordelingscriteria.item.redenVanStatus == 121450000);
	return {
		loading: disabled,
		beoordelingscriteria: beoordelingscriteria.item,
		errors: beoordelingscriteria.errors,
		validationMessageType: beoordelingscriteria.hasValidationErrors ? types.ValidationMessageTypes.ERROR : types.ValidationMessageTypes.WARNING,
		dossierId: dossierId,
		fileTypes: state.settings.fileTypes
	};
}

function mapDispatchToProps(dispatch) {
	return {
		saveCriteria: bindActionCreators(criteriaTopsportActions.saveCriteriaTopsport, dispatch),
		loadCriteria: bindActionCreators(criteriaTopsportActions.loadCriteriaTopsport, dispatch),
		loadLayout: bindActionCreators(layoutActions.loadBeoordelingscriteriaPageLayout, dispatch),
		uploadDocument: bindActionCreators(documentActions.uploadDocument, dispatch),
		deleteDocument: bindActionCreators(documentActions.deleteDocument, dispatch),
		startFileSession: bindActionCreators(documentActions.startFileSession, dispatch),
		endFileSession: bindActionCreators(documentActions.endFileSession, dispatch),
		getContent: bindActionCreators(documentActions.getContent, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(BeoordelingscriteriaTopsportPage));
